import { mapState } from 'vuex';
import { convertDateToISO8601 } from '@/utils/date';
import config from '@/config';
import axios from 'axios';

export default {
  data() {
    return {
      loading: false,
      dataRefreshCounter: 0,
      selectedTimeUnit: 'day',
      selectedTimeGroupingUnit: 'D',
      dataCollection: null,
    };
  },
  computed: {
    ...mapState('app', [
      'logging',
    ]),
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    dtFromStr() {
      return convertDateToISO8601(this.logging.selectedDtRange.from);
    },
    dtToStr() {
      return convertDateToISO8601(this.logging.selectedDtRange.to);
    },
  },
  methods: {
    refreshData() {
      this.dataRefreshCounter += 1;
    },
    loadData() {
      const url = new URL(
        config.ICOOL.API.LOG_EVENTS_PATH(this.currentSnapshot.id),
        config.ICOOL.BACKEND_HOST,
      ).href;
      const options = {
        params: {
          vars: this.varsIds + '',
          from: this.dtFromStr,
          to: this.dtToStr,
          freq: this.selectedTimeGroupingUnit,
        },
      };
      return new Promise((resolve, reject) => {
        axios
          .get(url, options)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      });
    },
    processData(data) {
      return data.datasets;
    },
    initData() {
      this.loading = true;
      this.loadData().then((data) => {
        this.dataCollection = this.processData(data);
        this.refreshData();
        this.loading = false;
      });
    },
  },
  beforeMount() {
    this.initData();
  },
  watch: {
    selectedTimeGroupingUnit() {
      this.initData();
    },
    dtFromStr() {
      this.initData();
    },
    dtToStr() {
      this.initData();
    },
  },
};
